import type { SkyscannerRankexplainabilityV1 } from '@skyscanner-internal/rank-explainability-web-http-client';

export type RankExplainabilityMessageType = SkyscannerRankexplainabilityV1.MessageType;

export const MESSAGE_TYPE = {
  MESSAGE_TYPE_UNSPECIFIED: 'MESSAGE_TYPE_UNSPECIFIED',
  MESSAGE_TYPE_NO_MESSAGE: 'MESSAGE_TYPE_NO_MESSAGE',
  MESSAGE_TYPE_IDENTICAL_DIRECT: 'MESSAGE_TYPE_IDENTICAL_DIRECT',
  MESSAGE_TYPE_IDENTICAL_FASTER: 'MESSAGE_TYPE_IDENTICAL_FASTER',
  MESSAGE_TYPE_IDENTICAL_NIGHT: 'MESSAGE_TYPE_IDENTICAL_NIGHT',
  MESSAGE_TYPE_IDENTICAL_NONE: 'MESSAGE_TYPE_IDENTICAL_NONE',
  MESSAGE_TYPE_WITHIN_THRESHOLD_DIRECT: 'MESSAGE_TYPE_WITHIN_THRESHOLD_DIRECT',
  MESSAGE_TYPE_WITHIN_THRESHOLD_FASTER: 'MESSAGE_TYPE_WITHIN_THRESHOLD_FASTER',
  MESSAGE_TYPE_WITHIN_THRESHOLD_NIGHT: 'MESSAGE_TYPE_WITHIN_THRESHOLD_NIGHT',
  MESSAGE_TYPE_OVER_THRESHOLD_DIRECT: 'MESSAGE_TYPE_OVER_THRESHOLD_DIRECT',
  MESSAGE_TYPE_OVER_THRESHOLD_FASTER: 'MESSAGE_TYPE_OVER_THRESHOLD_FASTER',
  MESSAGE_TYPE_OVER_THRESHOLD_NIGHT: 'MESSAGE_TYPE_OVER_THRESHOLD_NIGHT',
  MESSAGE_TYPE_CHEAPEST_AND_FASTEST: 'MESSAGE_TYPE_CHEAPEST_AND_FASTEST',
  MESSAGE_TYPE_BEST_IS_FASTEST: 'MESSAGE_TYPE_BEST_IS_FASTEST',
  MESSAGE_TYPE_NEAR_FASTEST_CHEAPER: 'MESSAGE_TYPE_NEAR_FASTEST_CHEAPER',
  MESSAGE_TYPE_SHORT_LAYOVER: 'MESSAGE_TYPE_SHORT_LAYOVER',
  MESSAGE_TYPE_GOOD_ARRIVAL_TIMES: 'MESSAGE_TYPE_GOOD_ARRIVAL_TIMES',
  MESSAGE_TYPE_GENERIC_DURATION_AND_PRICE: 'MESSAGE_TYPE_GENERIC_DURATION_AND_PRICE',
} as const satisfies { [K in RankExplainabilityMessageType]: K };
